// *********************************
// CoolGames Builder JavaScript file
import { tgfSettings } from "../../game_logic/framework/tgfSettings";
// *********************************
export var tgfSettingsOverride = function () {
    "use strict";
    tgfSettings.nakama = {
        // AngryBirds DEMO
        key: "KLT3NwSsXCGtzd3GIhr",
        endpoint: "public.angry-birds.nakama.sandbox.cg-gb.com",
        isProdVersion: false,
        // AngryBirds DEMO
        fbAppId: "231078497395889",
        // AngryBirds DEMO
        fbAppToken: "EAADSKifApLEBAFITnMLWd8xR53ynCf3ZAA14Y2Ia7RIw1aW05psE8fQzGT4uRxZCR5LruXvc9dZBZAPUmBsGWgRFaaBHlKiZB1d2shdyGLBPvR9AHYehXEAMmwQgL762Y9Yyjuz8Og3ukW7RLVa4zvr9KgmTd5AGbfAAImXws7wZDZD"
    };
    tgfSettings.environment = "DEMO";
    tgfSettings.enableDebugSettings = false;
    tgfSettings.facebook = {
        // AngryBirds DEMO
        rewardedVideoPlacementId: "1825153594465039_1838291466484585",
        interstitialPlacementId: "1825153594465039_1935367346776996"
    };
    tgfSettings.analytics = {
        beaconGameKey: "abinstantstage_4a42b1a6",
        beaconSecretKey: "X1N8mfc0BjdRMSDcT4D9PCMAnXYtyp67",
        beaconDebugMessages: true
    };
    tgfSettings.matchTurnExpirationTime = (72 * 60 * 60); // in seconds
};
